import App from '@/models/App'
import OrderingOrdererAccount from '@/models/OrderingOrdererAccount'

export default class OrderingOrdererOrderStatusLog extends App {
    static get entity() {
        return 'OrderingOrdererOrderStatusLogs'
    }

    static all() {
        return this.query().with('orderingOrderAccount.user').get()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingOrderId: this.attr(''),
            orderingAccountId: this.attr(''),
            status: this.attr(0),
            prevStatus: this.attr(false),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            orderingAccount: this.belongsTo(
                OrderingOrdererAccount,
                'orderingAccountId'
            ),
        }
    }

    static apiConfig = {
        actions: {},
    }
}
